import {
    mailboxQuotaPercentFull,
    mailboxQuotaBlockSend,
    mailboxQuotaWarning,
    viewStorage,
} from './showNotificationOnMailboxQuotaWarning.locstring.json';
import loc, { format } from 'owa-localize';
import { lazyShowNotification, NotificationBarCallbackReason } from 'owa-notification-bar';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import getAccountInformationService from '../../services/getAccountInformationService';
import UnlimitedUnsignedInteger from 'owa-service/lib/contract/UnlimitedUnsignedInteger';
import { logUsage } from 'owa-analytics';

const SHOW_NOTIFICATION_PERCENTAGE = 95;
const SHOW_ALERT_PERCENTAGE = 98;

/**
 * show notification on mailbox quota warning
 */
export default function showNotificationOnMailBoxQuotaWarning() {
    getAccountInformationService().then(jsonResponse => {
        let totalMbxSize: UnlimitedUnsignedInteger;
        const currentMbxUsed = jsonResponse.AccountInfo.Statistics.TotalItemSize.Value;

        if (jsonResponse.AccountInfo.Mailbox.UseDatabaseQuotaDefaults) {
            totalMbxSize = jsonResponse.AccountInfo.Statistics.DatabaseProhibitSendReceiveQuota;
        } else {
            totalMbxSize = jsonResponse.AccountInfo.Mailbox.ProhibitSendReceiveQuota;
        }

        const percentFull = (currentMbxUsed / totalMbxSize.Value) * 100;
        if (percentFull < SHOW_NOTIFICATION_PERCENTAGE || totalMbxSize.IsUnlimited) {
            return;
        }

        logUsage('TnS_MailboxQuotaWarning', [Math.round(percentFull)]);

        let notificationText = format(loc(mailboxQuotaPercentFull), percentFull.toFixed(2));

        notificationText +=
            percentFull >= SHOW_ALERT_PERCENTAGE
                ? loc(mailboxQuotaBlockSend)
                : loc(mailboxQuotaWarning);
        lazyShowNotification.importAndExecute(
            'mailboxQuotaWarningNotification',
            'MailModuleNotificationBarHost',
            notificationText,
            {
                primaryActionText: loc(viewStorage),
                allowAutoDismiss: false,
                shouldShowDismissIcon: true,
                notificationCallback: reason => {
                    if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                        lazyMountAndShowFullOptions.importAndExecute('general', 'storage');
                    }
                },
            }
        );
    });
}
